import React, { useState } from 'react';
import { FiHome, FiUsers, FiPhoneCall, FiDollarSign, FiSettings, FiActivity, FiLogOut, FiFileText } from 'react-icons/fi';
import AdminOverview from './AdminOverview';
import AdminUsers from './AdminUsers';
import AdminCalls from './AdminCalls';
import AdminWallet from './AdminWallet';
import AdminSettings from './AdminSettings';
import AdminLogin from './AdminLogin';
import AdminHealth from './AdminHealth';
import AdminBlogs from './AdminBlogs';
import AdminBlogEditor from './AdminBlogEditor';

const AdminDashboard = () => {
    const [activeTab, setActiveTab] = useState('overview');
    const [isAuthenticated, setIsAuthenticated] = useState(!!localStorage.getItem('adminToken'));
    const [blogEditorId, setBlogEditorId] = useState(null); // null = new, string = edit

    if (!isAuthenticated) {
        return <AdminLogin onLoginSuccess={() => setIsAuthenticated(true)} />;
    }

    const menuItems = [
        { id: 'overview', label: 'Overview', icon: <FiActivity /> },
        { id: 'users', label: 'Users & Guests', icon: <FiUsers /> },
        { id: 'calls', label: 'Call Logs', icon: <FiPhoneCall /> },
        { id: 'wallet', label: 'Wallet Ledger', icon: <FiDollarSign /> },
        { id: 'settings', label: 'Pricing & Rules', icon: <FiSettings /> },
        { id: 'health', label: 'System Health', icon: <FiActivity /> },
        { id: 'blogs', label: 'Blog Management', icon: <FiFileText /> },
    ];

    const handleLogout = () => {
        localStorage.removeItem('adminToken');
        setIsAuthenticated(false);
    };

    const renderContent = () => {
        switch (activeTab) {
            case 'overview': return <AdminOverview />;
            case 'users': return <AdminUsers />;
            case 'calls': return <AdminCalls />;
            case 'wallet': return <AdminWallet />;
            case 'settings': return <AdminSettings />;
            case 'health': return <AdminHealth />;
            case 'blog-editor': return (
                <AdminBlogEditor
                    postId={blogEditorId}
                    onBack={() => setActiveTab('blogs')}
                />
            );
            case 'blogs': return (
                <AdminBlogs
                    onNavigateToEditor={(id) => { setBlogEditorId(id); setActiveTab('blog-editor'); }}
                />
            );
            default: return <AdminOverview />;
        }
    };

    return (
        <div style={{ display: 'flex', minHeight: '100vh', width: '100%', background: 'var(--bg-dark)', overflow: 'hidden' }}>
            {/* Sidebar */}
            <div style={{ width: '260px', background: 'rgba(255,255,255,0.03)', borderRight: '1px solid var(--border)', padding: '2rem 1rem' }}>
                <h2 style={{ fontSize: '1.25rem', marginBottom: '2rem', padding: '0 1rem', display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <FiActivity color="var(--primary)" /> Admin Panel
                </h2>
                <nav style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                    {menuItems.map(item => (
                        <button
                            key={item.id}
                            onClick={() => setActiveTab(item.id)}
                            style={{
                                display: 'flex', alignItems: 'center', gap: '12px', padding: '12px 16px',
                                borderRadius: '12px', border: 'none', cursor: 'pointer', transition: 'all 0.2s',
                                background: activeTab === item.id ? 'var(--primary)' : 'transparent',
                                color: activeTab === item.id ? 'white' : 'var(--text-muted)',
                                fontWeight: 600, textAlign: 'left'
                            }}
                        >
                            {item.icon}
                            {item.label}
                        </button>
                    ))}
                </nav>
                <div style={{ marginTop: 'auto', paddingTop: '2rem' }}>
                    <button
                        onClick={handleLogout}
                        style={{
                            display: 'flex', alignItems: 'center', gap: '12px', padding: '12px 16px',
                            borderRadius: '12px', border: 'none', cursor: 'pointer', transition: 'all 0.2s',
                            background: 'rgba(239, 68, 68, 0.1)', color: 'var(--danger)',
                            fontWeight: 600, width: '100%', textAlign: 'left'
                        }}
                    >
                        <FiLogOut />
                        Logout
                    </button>
                </div>
            </div>

            {/* Main Content */}
            <div style={{ flex: 1, padding: '2.5rem', overflowY: 'auto' }}>
                {renderContent()}
            </div>
        </div>
    );
};

export default AdminDashboard;
